import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading, currentAccount } = useAuth();
  const location = useLocation();

  //ensures auth credentials are fully loaded before checking
  if (loading) return <div>Checking auth credentials...</div>;

  //reroute to root where they can log in
  if (!user) {
    //remember where the user is headed before we redirect
    const resumePath = location.pathname + location.search + location.hash;
    localStorage.setItem("resumePath", resumePath);
    const path = currentAccount ? `/login/${currentAccount?.slug}` : `/login`;
    return <Navigate to={path} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
